import { Controller } from 'stimulus'
import { defaultPropertiesAction } from '../constants/analytics'

export default class extends Controller {
  static values = { actionId: String, actionTitle: String }

  trackDelete() {
    const deleteProperties = {
      action_title: this.actionTitleValue,
      action_id: this.actionIdValue,
      actions_deleted_count: 1
    }
    this.sendAnalytics('Action Deleted', deleteProperties)
  }

  sendAnalytics(eventName, eventProperties) {
    const properties = { ...defaultPropertiesAction, ...eventProperties }
    analytics.track(eventName, properties)
  }
}
